import React, { Component } from 'react';
import axios from 'axios';
import Card from 'react-bootstrap/Card';
import UploadImageToS3WithReactS3 from './uploadImage';
import Delete from './Delete';
import '../style/profile.css';

const server = process.env.REACT_APP_SERVER;

class Profile extends Component {
    constructor(props){
        super(props);
        this.state = {
            selectedFile: null,
            userImages: [],
            currentUpload: '',
            username: ''
        }
    }

    componentDidMount = async() => {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.props.token}` }
            };
            const response = await axios.get(`${server}/meme/${this.props.userId}`, config);
            const images = response.data.reverse();
            this.setState({userImages: images})
        } catch (err) {
            console.error(err.message)
        }
    }

    deleteMeme = async(id) => {
        try{
            let images = this.state.userImages;

            images.forEach(meme => {
                if(meme._id === id){
                    images.splice(images.indexOf(meme), 1);
                }
            })

            this.setState({userImages: images})

            const config = {
                headers: { Authorization: `Bearer ${this.props.token}` }
            };

            await axios.delete(`${server}/meme/${id}`, config);
            alert('Meme destroyed!');
        } catch(err) {
            console.error(err.message)
        }
    }

    addMeme = (meme) => {
        try {
            let images = this.state.userImages;
            images.push(meme);
            this.setState({userImages: images})
        } catch (err) {
            console.error(err.message)
        }
    }

    render() {
        return (
            <>
                {
                this.state.userImages === undefined ?
                <div id="user-back-container">
                    <h3 className="nothing" style={{color: "white"}}>Nothing to see here...</h3>
                </div>
                :
                this.state.userImages.map((imageObj, idx) => (
                    <Card id="meme-card" key={imageObj._id} index={idx} className="mx-auto mb-5 mt-2 float-left" bg="dark" text="light">
                        <Card.Img variant="top" alt={imageObj.uploaderId} src={imageObj.imageUrl} />  
                        <Card.ImgOverlay>
                            <Card.Title>                       
                                <Delete className="info" deleteMeme={this.deleteMeme} memeId={imageObj._id}>x</Delete>
                            </Card.Title>
                        </Card.ImgOverlay>
                    </Card>
                ))
                }
                <div className="upload-form">
                    <div className="auth-inner">
                        <UploadImageToS3WithReactS3 token={this.props.token} addMeme={this.addMeme} userId={this.props.userId} username={this.props.username} />
                    </div>
                </div>
            </>
        )
    };
}

export default Profile;
